import { ReactElement } from "react";
import { Link, useSearchParams } from "react-router-dom";

interface DealmakerPagerProps {
  page: number;
  pageCount: number;
  pageKey: "page" | "archivedPage";
}

export default function DealmakerPager({ page, pageCount, pageKey }: DealmakerPagerProps): ReactElement | null {
  const [params] = useSearchParams();
  if (pageCount <= 1) {
    return null;
  }
  const start = pageCount <= 5 ? 1 : Math.max(1, Math.min(page - 2, pageCount - 4));
  const end = Math.min(pageCount, start + 4);
  const pages: number[] = [];
  for (let number = start; number <= end; number += 1) {
    pages.push(number);
  }

  function href(nextPage: number): string {
    const next = new URLSearchParams(params);
    next.set("action", "search");
    next.set(pageKey, String(nextPage));
    return `/dealmaker?${next.toString()}`;
  }

  return (
    <nav className="dealmaker-pager" aria-label={pageKey === "page" ? "Active deals" : "Archived deals"}>
      {page > 1 ? <Link to={href(page - 1)}>Prev</Link> : null}
      {pages.map((number) => (
        number === page
          ? <span key={number} className="is-current">{number}</span>
          : <Link key={number} to={href(number)}>{number}</Link>
      ))}
      {page < pageCount ? <Link to={href(page + 1)}>Next</Link> : null}
    </nav>
  );
}
